import { render } from "./Cooperative.vue?vue&type=template&id=314f4997&scoped=true"
import script from "./Cooperative.vue?vue&type=script&lang=js"
export * from "./Cooperative.vue?vue&type=script&lang=js"

import "./Cooperative.vue?vue&type=style&index=0&id=314f4997&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314f4997"]])

export default __exports__